import React, { FC, useState }                 from "react";
import { useDispatch, useSelector }            from "react-redux";
import { Button, Form, Icon, Modal, TextArea } from "semantic-ui-react";
import UpdateMailTemplate
                                               from "../../../../../application/usecase/mail/template/UpdateMailTemplate";
import MailTemplate                            from "../../../../../domain/mail/template/MailTemplate";
import MailTemplateContent                     from "../../../../../domain/mail/template/MailTemplateContent";
import MailTemplateName                        from "../../../../../domain/mail/template/MailTemplateName";
import MailTemplateRepository                  from "../../../../../domain/mail/template/MailTemplateRepository";
import MailTemplateSubject                     from "../../../../../domain/mail/template/MailTemplateSubject";
import { ResKaState }                          from "../../../../../index";
import MailTemplateDataSource
                                               from "../../../../../infrastructure/datasource/mail/template/MailTemplateDataSource";
import ValidatorMessage                        from "../../../message/ValidatorMessage";

interface Props {
  mailTemplate: MailTemplate;
}

const MailTemplateUpdateFormButton: FC<Props> = (props: Props) => {
  const [open, setOpen] = useState(false);
  const repository: MailTemplateRepository = new MailTemplateDataSource(useDispatch());
  const mailTemplate: MailTemplate = useSelector((state: ResKaState) => state.mailTemplate);
  const updateMailTemplate: UpdateMailTemplate = new UpdateMailTemplate(useDispatch());

  return (
    <>
      <Button
        icon
        labelPosition="left"
        onClick={ () => {
          repository.setMailTemplate(props.mailTemplate);
          setOpen(true);
        } }
      >
        <Icon name="edit"/>
        編集する
      </Button>

      <Modal
        open={ open }
      >
        <Modal.Header>メール雛形編集</Modal.Header>
        <Modal.Content>
          <Form>
            <Form.Field required>
              <label>メール雛形名称</label>
              <Form.Input
                placeholder="用途などわかりやすい名称を入力してください。"
                defaultValue={ mailTemplate.name.value }
                onChange={ (event, data) => repository.setMailTemplateName(new MailTemplateName(data.value)) }
              />
              <ValidatorMessage target="name"/>
            </Form.Field>
            <Form.Field required>
              <label>メール件名</label>
              <Form.Input
                placeholder="メール送信時に設定したい件名を入力さいてください。"
                defaultValue={ mailTemplate.subject.value }
                onChange={ (event, data) => repository.setMailTemplateSubject(new MailTemplateSubject(data.value)) }
              />
              <ValidatorMessage target="subject"/>
            </Form.Field>
            <Form.Field>
              <label>メール本文</label>
              <TextArea
                placeholder="メール送信時に設定したい本文を入力してください。"
                rows={ 20 }
                defaultValue={ mailTemplate.content.value }
                onChange={ (event, data) => repository.setMailTemplateContent(new MailTemplateContent(data.value as string)) }
              />
            </Form.Field>
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button
            icon
            labelPosition="left"
            positive
            onClick={ () => updateMailTemplate.execute(mailTemplate, setOpen) }
          >
            <Icon name="save"/>
            保存する
          </Button>

          <Button onClick={ () => setOpen(false) }>閉じる</Button>
        </Modal.Actions>
      </Modal>
    </>
  );
};

export default MailTemplateUpdateFormButton;
